import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleLike: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeopleLike"><Path d="M16 6.5C16 8.70914 14.2091 10.5 12 10.5C9.79086 10.5 8 8.70914 8 6.5C8 4.29086 9.79086 2.5 12 2.5C14.2091 2.5 16 4.29086 16 6.5Z" stroke="currentColor"/><Path d="M13 20.5H4C4 16.0817 7.58172 12.5 12 12.5C12.8731 12.5 13.7135 12.6399 14.5 12.8984" stroke="currentColor"/><Path d="M21.5 17.6089C21.5 20.1212 18 21.5 18 21.5C18 21.5 14.5 20.1212 14.5 17.6089C14.5 15.7261 16.3813 14.6052 18 15.6513C19.6187 14.6052 21.5 15.7261 21.5 17.6089Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeopleLike;
